module.exports = __webpack_public_path__ + "static/media/customer-managementcrm.39433e84.svg";